import React, {Component} from 'react';
import Field from '../Field';
import SubmitInput from '../Fields/SubmitInput';
import HeaderSteps from '../Fragments/HeaderSteps';
import SaveForLaterModal from '../Fragments/SaveForLaterModal';
import FullPageSpinner from '../Fragments/FullPageSpinner';
import { browserHistory } from 'react-router';
let Validation = require('../Managers/Validation.js');

// Reusable strings for residence types
let rt1 = 'Letting agent';
let rt2 = 'Solicitor';
let rt3 = 'Landlord';

let Config = require('Config');
let Quote =  require('../Managers/Quote');
let HttpService = require('../Managers/HttpService');

export default class ResidenceDetails extends Component {
    constructor(props) {
        super(props);
        // default to one tenant. do not presume current address provider.
        this.state = {
            tenantNumber: 1,
            areStepQuestionsNeeded: null,
            areRentFrequencyQuestionsNeeded: null,
            isPaymentFrequencyMonthly: null,
            isPaymentFrequencyWeekly: null,
            isPaymentFrequencyOther: null,
            rentalAmountLabel: 'How much is your current rent?',
            isForeignAddress: false,
            isFullPageSpinnerActive: false,
        };
        this.inputComponents = [];
        this.childComponents = [];
    }

    componentDidMount() {
        $('html, body').animate({
            scrollTop: $('body').offset().top - $('header.site-header').height()
        }, 500);
    }

    componentWillUpdate() {
        this.inputComponents = [];
        this.childComponents = [];
    }

    componentWillUnmount() {
        this.inputComponents = [];
        this.childComponents = [];
    }

    handleChildUpdate(v) {
        switch(v) {
            case 1:
                this.setState({ residenceType: rt1 });
                break;
            case 2:
                this.setState({ residenceType: rt2 });
                break;
            default:
                this.setState({ residenceType: rt3 });
                break;
        }
        this.setState({areRentFrequencyQuestionsNeeded:true});
    }

    /**
     * Only show other questions on this step if the user selects 'tenant' as
     * their residential status.
     *
     * @param v value from the callback
     */
    handleResidenceStatus(v) {
        if (v === Config.residentialStatusTypes.PRIVATE_TENANT) {
            this.setState({areStepQuestionsNeeded: true});
        } else {
            this.setState({areStepQuestionsNeeded: false});
            Quote.deleteByPath('BaseIndividualApplication.lettingReferee');
        }
    }

    handleRentFrequency(v) {
        switch(v) {
            case 1: // weekly
                this.setState({
                    isPaymentFrequencyMonthly: false,
                    isPaymentFrequencyWeekly: true,
                    isPaymentFrequencyOther: false,
                    rentalAmountLabel: 'How much is your current weekly rent?'
                });
                break;
            case 2: // 4-weekly
                this.setState({
                    isPaymentFrequencyMonthly: false,
                    isPaymentFrequencyWeekly: false,
                    isPaymentFrequencyOther: false,
                    rentalAmountLabel: 'How much rent do you currently pay every 4 weeks?'
                });
                break;
            case 3: // monthly
                this.setState({
                    isPaymentFrequencyMonthly: true,
                    isPaymentFrequencyWeekly: false,
                    isPaymentFrequencyOther: false,
                    rentalAmountLabel: 'How much is your current monthly rent?'
                });
                break;
            default:
                this.setState({
                    isPaymentFrequencyMonthly: false,
                    isPaymentFrequencyWeekly: false,
                    isPaymentFrequencyOther: true,
                });
                break;
        }
    }

    // todo: gross manual step transitions until we have a step manager
    manualStepProgression() {
        this.setState({ isFullPageSpinnerActive: true });
        let inputComponents = [];

        this.childComponents.filter(c => {
            return (c !== undefined) && (c !== null);
        }).map(c => {
            inputComponents = inputComponents.concat(c.getChildInputComponents());
        });

        inputComponents = inputComponents.filter(c => {
            return (c !== undefined) && (c !== null);
        });

        inputComponents = inputComponents.concat(this.inputComponents).filter(c => {
            return (c !== undefined) && (c !== null);
        });

        inputComponents.map(v => {
            v.getChildInstance().handleValidation(v.getChildInstance().getCurrentValue());
        });

        setTimeout(() => {
            this.setState({ isFullPageSpinnerActive: false });
            if (document.querySelectorAll('.has-error').length > 0) {
                $('html, body').animate({
                    scrollTop: $(".has-error").first().offset().top - $('header.site-header').height()
                }, 500);
            } else {
                if (Quote.getByPath('BaseIndividualApplication.studentOnlyApplication') === true) {
                    // Tenancy start date > 60 days in the future, so must be a
                    // tenant.
                    browserHistory.push('/application/additional-details');
                } else {
                    browserHistory.push('/application/your-finances');
                }
            }
        }, 1000);
    }

    isForeignAddress(v) {
        this.setState({ isForeignAddress: v });
    }

    render() {
        let t = '-tenant' + this.state.tenantNumber;
        return(
            <div>
                <HeaderSteps current={3} />

                <FullPageSpinner
                    isActive={this.state.isFullPageSpinnerActive}
                />

                <question-row class="no-border">
                    <h1>Current residential status</h1>
                </question-row>
                <Field
                    fieldName={'residenceStatus' + t}
                    question="What is your current residential status?"
                    storageKey="residentialStatus"
                    type="button-choice"
                    options={[
                        {
                            value: Config.residentialStatusTypes.PROPERTY_OWNER,
                            text: 'Homeowner'
                        },
                        {
                            value: Config.residentialStatusTypes.LIVING_WITH_RELATIVES,
                            text: 'Living with friends/relatives'
                        },
                        {
                            value: Config.residentialStatusTypes.PRIVATE_TENANT,
                            text: 'Tenant'
                        }
                    ]}
                    callbackFunction={this.handleResidenceStatus.bind(this)}
                    helpText="This is for your current living arrangements only."
                    labelExtra="Please only select tenant if you're named on the tenancy agreement."
                    dataValidation="required_field"
                    source="BaseIndividualApplication"
                    loadingKey={'BaseIndividualApplication.residenceStatus'}
                    loadValues={true}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />

                {this.state.areStepQuestionsNeeded === true ?
                    <div>
                        <Field
                            question="Who do you currently rent your property through?"
                            fieldName={'residenceType' + t}
                            storageKey="type"
                            type="button-choice"
                            options={[
                                {
                                    value: Config.lettingRefereeTypes.LETTING_ESTATE_AGENT,
                                    text: rt1
                                },
                                {
                                    value: Config.lettingRefereeTypes.LANDLORD,
                                    text: rt3
                                },
                                {
                                    value: Config.lettingRefereeTypes.SOLICITOR,
                                    text: rt2
                                }
                            ]}
                            callbackFunction={this.handleChildUpdate.bind(this)}
                            dataValidation="required_field"
                            source="BaseIndividualApplication.lettingReferee"
                            loadingKey={'BaseIndividualApplication.residenceStatus'}
                            loadValues={true}
                            ref={(instance) => {this.inputComponents.push(instance);}}
                        />

                        {this.state.residenceType ?
                            <div>
                                <Field
                                    fieldName={'residenceName' + t}
                                    question={this.state.residenceType + ' name'}
                                    storageKey="name"
                                    type="text"
                                    dataValidation="required_field"
                                    maxLength={60}
                                    source="BaseIndividualApplication.lettingReferee"
                                    loadingKey={'BaseIndividualApplication.lettingReferee.name'}
                                    loadValues={true}
                                    ref={(instance) => {this.inputComponents.push(instance);}}
                                />
                                <Field
                                    type="address"
                                    fieldName={this.state.residenceType + '_' + t}
                                    question={this.state.residenceType + ' address'}
                                    storageKey="address"
                                    addressOptions={{
                                        canHaveManualEntry: true,
                                        canBeForeign: true,
                                        pafLookup: true,
                                        hasManualEntryOption:true,
                                    }}
                                    callbackFunction={this.isForeignAddress.bind(this)}
                                    source="BaseIndividualApplication.lettingReferee.address"
                                    loadingKey={'BaseIndividualApplication.lettingReferee.address'}
                                    loadValues={true}
                                    ref={(instance) => {
                                        this.inputComponents.push(instance);
                                        this.childComponents.push(instance);
                                    }}
                                />
                                {this.state.isForeignAddress === false ?
                                    <Field
                                        type="text"
                                        maxLength={11}
                                        fieldName={'residenceMobile' + t}
                                        question={this.state.residenceType + ' mobile number (UK only)'}
                                        storageKey="mobile"
                                        dataValidation="mobile_number.non_mandatory"
                                        helpText={'Providing a mobile number for your ' + this.state.residenceType.toLowerCase() + ' can help speed up the application process.'}
                                        source="BaseIndividualApplication.lettingReferee"
                                        loadingKey={'BaseIndividualApplication.lettingReferee.mobile'}
                                        loadValues={true}
                                        inValidOverride={() => { return Validation.doesLettingRefereeNumbersMatchApplication('mobile'); }}
                                        ref={(instance) => { this.inputComponents.push(instance); }}
                                    />
                                : null}
                                <Field
                                    type="email"
                                    fieldName={'residenceEmail' + t}
                                    question={this.state.residenceType + ' email address'}
                                    storageKey="email"
                                    dataValidation="email_address.non_mandatory"
                                    source="BaseIndividualApplication.lettingReferee"
                                    loadingKey={'BaseIndividualApplication.lettingReferee.email'}
                                    loadValues={true}
                                    inValidOverride={() => {
                                        let applicationEmail = Quote.getByPath('BaseIndividualApplication.email');
                                        let landlordEmail = Quote.getByPath('BaseIndividualApplication.lettingReferee.email');

                                        if (window.uornorb(applicationEmail) || window.uornorb(landlordEmail)) {
                                            return {
                                                isValid: true,
                                                hasError: false,
                                                errors: [],
                                            };
                                        } else {
                                            if (applicationEmail == landlordEmail) {
                                                return {
                                                    isValid: false,
                                                    hasError: true,
                                                    errors: ["Email must not be the same as tenant contact details"],
                                                };
                                            } else {
                                                return {
                                                    isValid: true,
                                                    hasError: false,
                                                    errors: [],
                                                };
                                            }
                                        }
                                    }}
                                    ref={(instance) => {this.inputComponents.push(instance);}}
                                />
                                <Field
                                    type="text"
                                    maxLength={20}
                                    fieldName={'residencePhone' + t}
                                    question={this.state.residenceType + ' telephone number'}
                                    storageKey="phone"
                                    dataValidation="phone_number"
                                    source="BaseIndividualApplication.lettingReferee"
                                    loadingKey={'BaseIndividualApplication.lettingReferee.phone'}
                                    loadValues={true}
                                    inValidOverride={() => { return Validation.doesLettingRefereeNumbersMatchApplication('phone'); }}
                                    ref={(instance) => { this.inputComponents.push(instance); }}
                                />
                            </div>
                        : null}

                        {this.state.areRentFrequencyQuestionsNeeded === true ?
                            <Field
                                fieldName={'residenceRentalFrequency' + t}
                                question="How frequently do you pay your rent?"
                                storageKey="paymentFrequency"
                                type="button-choice"
                                options={[
                                    {
                                        value: Config.lettingRefereePaymentFrequencies.MONTHLY,
                                        text: 'Monthly'
                                    },
                                    {
                                        value: Config.lettingRefereePaymentFrequencies.FOUR_WEEKLY,
                                        text: '4 weekly'
                                    },
                                    {
                                        value: Config.lettingRefereePaymentFrequencies.WEEKLY,
                                        text: 'Weekly'
                                    },
                                    {
                                        value: Config.lettingRefereePaymentFrequencies.ALL_IN_ONE,
                                        text: 'Full amount in advance'
                                    },
                                    {
                                        value: Config.lettingRefereePaymentFrequencies.OTHER,
                                        text: 'Other'
                                    }
                                ]}
                                callbackFunction={this.handleRentFrequency.bind(this)}
                                dataValidation="required_field"
                                source="BaseIndividualApplication.lettingReferee"
                                loadingKey={'BaseIndividualApplication.lettingReferee.paymentFrequency'}
                                loadValues={true}
                                ref={(instance) => {this.inputComponents.push(instance);}}
                            />
                        : null}

                        {this.state.isPaymentFrequencyOther === false ?
                            <div>
                                <Field
                                    type="money"
                                    fieldName={'residenceRentAmount' + t}
                                    question={this.state.rentalAmountLabel}
                                    storageKey="paymentAmount"
                                    dataValidation="required_field"
                                    source="BaseIndividualApplication.lettingReferee"
                                    loadingKey={'BaseIndividualApplication.lettingReferee.paymentAmount'}
                                    loadValues={true}
                                    ref={(instance) => {this.inputComponents.push(instance);}}
                                />

                                {this.state.isPaymentFrequencyMonthly === true ?
                                    <Field
                                        fieldName={'residenceRentDate' + t}
                                        question="What date is your rent due each month?"
                                        storageKey="paymentDayOfMonth"
                                        type="date"
                                        subType="day"
                                        dataValidation="required_field"
                                        source="BaseIndividualApplication.lettingReferee"
                                        loadingKey={'BaseIndividualApplication.lettingReferee.paymentDayOfMonth'}
                                        loadValues={true}
                                        ref={(instance) => {this.inputComponents.push(instance);}}
                                    />
                                : null}

                                {this.state.isPaymentFrequencyWeekly === true ?
                                    <Field
                                        fieldName={'residenceRentDate' + t}
                                        question="What day is your rent due?"
                                        storageKey="paymentDayOfWeek"
                                        type="date"
                                        subType="day-of-the-week"
                                        dataValidation="required_field"
                                        source="BaseIndividualApplication.lettingReferee"
                                        loadingKey={'BaseIndividualApplication.lettingReferee.paymentDayOfWeek'}
                                        loadValues={true}
                                        ref={(instance) => {this.inputComponents.push(instance);}}
                                    />
                                : null}

                                <Field
                                    fieldTitle="Fast Track"
                                    question="You can help reduce the time it takes to complete your reference by providing us with evidence of your rental payments."
                                    fieldName={'residenceEvidence' + t}
                                    storageKey="upload"
                                    type="upload"
                                    contextInfo={'Residence evidence'}
                                    allowFileUploads={true}
                                    allowCameraUploads={true}
                                    helpText={'<p>For this reference suitable documents are:</p><ul><li>A copy of the tenancy agreement and last 6 months bank statements showing rent being paid</li><li>A copy of the tenancy agreement and rental statement covering the last 6 months</li></ul>'}
                                    source="BaseIndividualApplication.lettingReferee"
                                />
                            </div>
                        : null}
                    </div>
                : null}

                {this.state.areStepQuestionsNeeded === false ?
                    <question-row>
                        <div className="question-main">
                            <p className="supplemental">
                                Please click next to continue.
                            </p>
                        </div>
                    </question-row>
                : null}

                <SaveForLaterModal
                    ref="SaveForLaterModal"
                />

                <SubmitInput
                    label="Next"
                    callbackFunction={this.manualStepProgression.bind(this)}
                    backLink={true}
                    saveForLater={false}
                    saveForLaterFunc={() => {
                        this.setState({ isFullPageSpinnerActive: true });
                        HttpService.applicationPutApplication(() => {
                            window.localStorage.removeItem('validationError');
                            this.setState({ isFullPageSpinnerActive: false });
                            this.refs.SaveForLaterModal.toggleIsActive();
                        }, (invalidData) => {
                            window.localStorage.setItem('validationError', JSON.stringify(invalidData));
                            browserHistory.push('/error/applicant-validation');
                        });
                    }}
                    currentNumber={3}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Screens/ResidenceDetails.js